// @mui
import { Container, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// sections
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
// components
import Page from '../components/Page';
import UsersData from '../components/dashboard/mainDashboards/UsersData';
import StudentsData from '../components/dashboard/mainDashboards/StudentsData';

// ----------------------------------------------------------------------

const url = process.env.REACT_APP_API_URL;

export default function DashboardApp() {


  return (
    <Page title="Dashboard">
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Hi, Welcome back
        </Typography>

        <Grid container rowGap={5}>

          <Grid item xs={12}>
            <StudentsData />
          </Grid>
          {/* <Grid item xs={12}>
            <UsersData />
          </Grid> */}

        </Grid>
      </Container>
    </Page>
  );
}
